import { createAction } from '@reduxjs/toolkit';
import * as containerConstants from './constants';
import type { CustomerType, SaleItem } from '@/lib/types';

export const loadSales = createAction(containerConstants.LOAD_SALES);
export const loadSalesSuccess = createAction(
  containerConstants.LOAD_SALES_SUCCESS,
  (sales: any[]) => ({ payload: { sales } })
);
export const loadSalesError = createAction(
  containerConstants.LOAD_SALES_ERROR,
  (error: string) => ({ payload: { error } })
);

export const loadCredits = createAction(containerConstants.LOAD_CREDITS);
export const loadCreditsSuccess = createAction(
  containerConstants.LOAD_CREDITS_SUCCESS,
  (credits: any[]) => ({ payload: { credits } })
);
export const loadCreditsError = createAction(
  containerConstants.LOAD_CREDITS_ERROR,
  (error: string) => ({ payload: { error } })
);

export const loadDueCollections = createAction(
  containerConstants.LOAD_DUE_COLLECTIONS
);

export const saveSaleRequest = createAction(
  'counter/SAVE_SALE_REQUEST',
  (
    sale: {
      cart: SaleItem[];
      paymentMethod: string;
      total: number;
      discountAmount?: number;
      customerId?: string;
      customerName?: string;
      customerType?: CustomerType;
      payNow: number;
    }
  ) => ({ payload: { sale } })
);

export const settleCreditRequest = createAction(
  'counter/SETTLE_CREDIT_REQUEST',
  (id: string, amount: number) => ({ payload: { id, amount } })
);

export const cancelSaleRequest = createAction(
  'counter/CANCEL_SALE_REQUEST',
  (id: string) => ({ payload: { id } })
);

export const saveSaleStarted = createAction('counter/SAVE_SALE_STARTED');

export const saveSaleSucceeded = createAction(
  'counter/SAVE_SALE_SUCCEEDED',
  (sale: any) => ({ payload: { sale } })
);

export const saveSaleFailed = createAction(
  'counter/SAVE_SALE_FAILED',
  (error: string) => ({ payload: { error } })
);

export const clearLastSale = createAction('counter/CLEAR_LAST_SALE');
